import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import VisitLogo from '../../images/visitlogo.svg';
import Bk from '../../images/Bk.svg';
import BlueBg from '../../images/BlueBg.svg';
import AppleStoreButton from '../../images/appleStoreButton.svg';
import GoogleStoreButton from '../../images/googleStoreButton.svg';
import Cross from '../../images/lab-test/cross.svg';
import { BoldText } from '../../components/common/Text';

const OuterContainer = styled.div`
  width: 100%;
  height: 100%;

  box-sizing: border-box;
  padding-top: 30px;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 30px;
  position: relative;
`;
const LogoContainer = styled.div`
  display: flex;
  margin-top: 25px;
  margin-bottom: 10px;
  gap: 10px;
  align-items: center;
`;
const MainTitle = styled.div`
  display: flex;
  padding-top: 25px;
  padding-bottom: 25px;
  flex-wrap: wrap;
  width: 250px;
`;

const DownloadContainer = styled.div`
  display: inline-flex;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0px 4px 12px 0px rgba(0, 50, 116, 0.24);
  width: 100%;
  position: relative;
  z-index: 1;
`;
const DownloadTitle = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-bottom: 40px;
`;
const TitleSliceOne = styled.span`
  color: var(--text-secondary-8, #a5a6bb);

  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 38.4px */
`;
const TitleSliceTwo = styled.span`
  color: var(--Primary, var(--primary-button));

  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
`;

const DownloadLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  padding-bottom: 15px;
  width: 100%;
  border-bottom: 2px solid #ebeaf5;
`;
const NoteContainer = styled.div`
  line-height: 0;
  display: flex;
  text-align: left;
  padding-top: 8px;
`;
const NoteHead = styled.span`
  color: #767787;

  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
`;
const NoteBody = styled.span`
  color: #767787;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  padding-left: 4px;
`;

const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const Download = () => {
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    const urlSearchString = window.location.search;
    const params = new URLSearchParams(urlSearchString);
    console.log(params.get('failed'));
    setFailed(params.get('failed'));
  }, []);
  return (
    <OuterContainer>
      <LogoContainer>
        <img src={VisitLogo} alt="Visit Logo" height={35} width={100} />
      </LogoContainer>
      <MainTitle />
      {failed ? (
        <ErrorContainer>
          <img width={80} src={Cross} alt="cross" />
          <BoldText>Payment Failed</BoldText>
          <div>Please connect with your agent.</div>
        </ErrorContainer>
      ) : (
        <DownloadContainer>
          <DownloadTitle>
            <TitleSliceOne>Download</TitleSliceOne>
            <TitleSliceTwo>Visit App</TitleSliceTwo>
          </DownloadTitle>
          <DownloadLinksContainer>
            <a href="https://vsyt.me/o/d" target="_blank" rel="noreferrer">
              <img src={AppleStoreButton} alt="" />
            </a>
            <a href="https://vsyt.me/o/d" target="_blank" rel="noreferrer">
              <img src={GoogleStoreButton} alt="" />
            </a>
          </DownloadLinksContainer>
          <NoteContainer>
            <NoteHead>
              Note:
              <NoteBody>
                Sign in with your mobile number to avail benefits.
              </NoteBody>
            </NoteHead>
          </NoteContainer>
        </DownloadContainer>
      )}
      <img
        src={BlueBg}
        style={{
          position: 'absolute',
          right: '0px',
          bottom: '0px',
        }}
        alt="org"
      />
      <img
        src={Bk}
        style={{
          position: 'absolute',
          bottom: '-4px',
          right: '-7px',
        }}
        alt="bk"
      />
    </OuterContainer>
  );
};
